import React from "react";
import KakaoMap from "./KakaoMap";

function App() {
  return <KakaoMap />;
  
}

export default App;